// removed by extract-text-webpack-plugin
module.exports = {"navigation":"navigation_navigation_U9dm8"};


//////////////////
// WEBPACK FOOTER
// ./src/docs/components/navigation.css
// module id = 72
// module chunks = 0